import { GetQuoteAccommodationModel } from "@factory/model/query-model-quote-accommodation";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { quoteAccommodationFormDefault } from "./form.default";
import { QuoteAccommodationFormSchema } from "./form.rule";

export const useFormDefaultQuoteAccommodation = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetQuoteAccommodationModel | undefined) => {
    return !cachedValue
      ? quoteAccommodationFormDefault
      : ({
          code: cachedValue.code,
          night: cachedValue.night,
          description: cachedValue.description,
          quotation: cachedValue.quotation,
          hotel: cachedValue.hotel,
          roomType: cachedValue.room_type,
          numPeople: cachedValue.num_people,
          unit: cachedValue.unit,
          validFrom: cachedValue.valid_from,
          validUntil: cachedValue.valid_until,
          name: cachedValue.name,
          price: cachedValue.price,
        } as QuoteAccommodationFormSchema);
  };

  return {
    getDefault,
  };
};
